var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 226.48 137.87",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-first_r{fill:#5157ac;}.cls-2{fill:#7491ec;}.cls-3{fill:#8ec8f6;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-first_r",
    d: "M131.68,83.85,113.24,102.3,91.09,124.45l-4,4-3.26,3.25a21.08,21.08,0,0,1-29.84,0L6.18,83.85A21.1,21.1,0,0,1,6.18,54L54,6.19a21.08,21.08,0,0,1,29.84,0l3.26,3.24L131.68,54A21.1,21.1,0,0,1,131.68,83.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M176,83.85l-40.59,40.6-7.23,7.23a21.09,21.09,0,0,1-29.85,0l-3.25-3.25,22.15-22.15L138,85.51c9.51-9.51,9.62-23.55.83-32.33L95.07,9.43l3.25-3.24a21.09,21.09,0,0,1,29.85,0l7.23,7.23L176,54A21.08,21.08,0,0,1,176,83.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M220.3,83.85l-40.59,40.6-7.23,7.23a21.09,21.09,0,0,1-29.85,0l-3.25-3.25,22.15-22.15,20.78-20.77c9.5-9.51,9.61-23.55.82-32.33L139.38,9.43l3.25-3.24a21.09,21.09,0,0,1,29.85,0l7.23,7.23L220.3,54A21.08,21.08,0,0,1,220.3,83.85Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.ae6721e84cda08416ccdb9ca9fe53543.svg";
export { ForwardRef as ReactComponent };